import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Modal, Button,
  ModalHeader,
  ModalBody,
  Col,
  Label,
} from "reactstrap";
import {
  AvForm, AvField,
  AvRadio,
  AvRadioGroup
} from "availity-reactstrap-validation";
import Loader from "components/Common/Loader";
import AvFieldSelect from "components/Common/AvFieldSelect";
import { editBonus, fetchAccountTypes } from "store/actions";
import { validateFile } from "pages/Transactions/Crypto/AddDepositForm";

const ClientType = ["LIVE"];
const PROCESS = ["Deposit", "Welcome", "Lot"];
const BONUSTYPE = ["DEPOSIT", "CREDIT_LOSE_APLE", "CREDIT_UNLOSE_APLE", ];
const baseUrl = process.env.REACT_APP_API_CRM_DOMAIN;


function BonusEdit({ open, onClose, selectBonus, t }) {
  const dispatch = useDispatch(); 
  const { updating, error } = useSelector((state) => state.bonusReducer);
  
  const [bonusType, setBonusType] = useState([]);
  const [file, setFile] = useState(null);
  const [process, setProcess] = useState();
  const [accountGroup, setAccountGroup] = useState({});
  const [bonusPercentage, setBonusPercentage] = useState(false);
  const [bonusDuration, setBonusDuration] = useState(false);
  console.log("selectBonus", selectBonus);
  console.log("accccccccccccccccc", accountGroup);
  console.log("Current process state:", process);
  const { accountTypes } = useSelector((state) => state.tradingAccountReducer);

  const formatDateForInput = (isoString) => {
    if (!isoString) return "";
    return new Date(isoString).toISOString().split("T")[0];
  };

  useEffect(() => {
    if (selectBonus) {
      // Set percentage state based on selectBonus.isPercentage
      setBonusPercentage(selectBonus?.isPercentage || false);
      
      // Set duration state based on whether dateFrom and dateTo exist
      const hasDates = selectBonus?.dateFrom && selectBonus?.dateTo;
      setBonusDuration(hasDates);
      setAccountGroup(selectBonus);
      setProcess(selectBonus.process);
    }
  }, [selectBonus, open]);
  useEffect(() => {
    if (process === "Lot") {
      setBonusPercentage(false);
    } else { 
      setBonusPercentage(selectBonus?.isPercentage || false);
    }
  }, [process]);

  useEffect(() => {
    (!updating && !error && open) && onClose();
  }, [updating]);
  
  useEffect(() => {
    loadAccountTypes();
  }, []);

  const loadAccountTypes = () => {
    dispatch(fetchAccountTypes());
  };

  const handleSubmit = (e, v) => {
    e.preventDefault();
    const id = selectBonus?._id;

    const formData = new FormData();
    formData.append("bonusName", v.bonusName);
    formData.append("process", process || v.process);
    formData.append("clientType", v.clientType);
    if (file){
      formData.append("banner", file);
    }

    formData.append("accountGroup", accountGroup?.title || accountGroup?.accountGroup);
    formData.append("bonusType", v.bonusType);
    formData.append("amount", parseFloat(v.amount) || 0);

    if (bonusPercentage) {
      formData.append("maxAmount", parseFloat(v.maxAmount ?? 0));
    }
    formData.append("accountType", selectBonus.accountType || accountGroup?._id ); 
    if (process === "Deposit") {
      formData.append("bonusLimit", parseInt(v.bonusLimit));
      formData.append("lotLimit", 0);

    }
    formData.append("desc", v.desc);    
    formData.append("isPercentage", bonusPercentage );  
    formData.append("percentage", parseFloat(v.percentage) || 0);
    formData.append("isPublic", v.isPublic);
    if (v.dateFrom && v.dateTo) {
      formData.append("dateFrom", v.dateFrom);
      formData.append("dateTo", v.dateTo);
    } 
    if (process === "Lot") {
      formData.append("lotLimit", v.lotLimit);
    }
    dispatch(editBonus({
      id,
      formData,
    }));
    onClose();
  };


  return (
    <>
      <Modal isOpen={open} toggle={onClose} centered={true}>
        <ModalHeader toggle={onClose} tag="h4">
          Edit Bonus
        </ModalHeader>
        <ModalBody >
          <AvForm
            className='px-4'
            onValidSubmit={(e, v) => { handleSubmit(e, v) }}
          >
            <AvField
              name="bonusName"
              label="Bonus Name"
              placeholder="Bonus Name "
              type="text"
              value={selectBonus?.bonusName || ""}
            />
            <AvFieldSelect
              name="process"
              label="Process"
              placeholder="Select Process"
              options={PROCESS?.map((type) => ({
                value: type,
                label: type
              }))}
              value={process || selectBonus?.process}
              onChange={(e) => {
                console.log("Process changed to:", e);
                setProcess(e);
              }}
            />

            {process === "Lot" && (
              <div className="d-flex  position-relative">
                <div className="position-relative w-100">
                  <AvField
                    name="lotLimit"
                    label={t("Lot Limit")}
                    placeholder={t("Enter Lot Limit")}
                    type={"number"}
                    min={0}
                    max={ 100 }
                    value={selectBonus.lotLimit}
                    onKeyPress={(e) => {
                      if (!isNaN(e.key) && e.target.value.length > 0) {
                        return true;
                      }
                      if (!/[0-9]/.test(e.key)) {
                        e.preventDefault();
                      }
                    }}
                    validate={{
                      pattern: {
                        value: "^[0-9]+$",
                        errorMessage: "max percentage is 100"
                      },
                    }}
                  />
                </div>
              </div>  
            )}
            
            <AvFieldSelect
              name="clientType"
              label="Client Type"
              placeholder="Select Client Type"
              options={ClientType.map((type) => ({
                value: type,
                label: type
              }))}
              value={selectBonus?.clientType}
            />
              
            <div className="mb-3">

              <Col md="12">
                <Label className="form-label" htmlFor="banner">
                  {t("Banner")} {selectBonus?.banner && "(Upload new to replace)"}
                </Label>
                <AvField
                  type="file"
                  name="banner"
                  className="form-control form-control-md"
                  errorMessage={t("Banner is required")}
                  onChange={(e) => {
                    setFile(e.target.files[0]);
                  }}
                  validate={{
                    validate: validateFile(["jpg", "jpeg", "png"], 1000000, file, {
                      sizeValidationMessage: t("The file size is too large"),
                      extensionValidationMessage: t("The file extension is not allowed"),
                    })
                  }}
                />
              </Col>
            </div>

            <div className="fs-3">
              <AvRadioGroup 
                inline 
                name="isPublic" 
                label={<span style={{ 
                  fontSize: "1rem",
                  fontWeight: "bold"
                }}>Visibility</span>} 
                value={selectBonus?.isPublic ? "true" : "false"}
                validate={{
                  required: {
                    value: true,
                    errorMessage: "status is required"
                  }
                }} 
              >
                <AvRadio label="Public" value="true" />
                <AvRadio label="Private" value="false" />
              </AvRadioGroup>
            </div>
                        
            <AvFieldSelect
              name="accountGroup"
              label="Account Group"
              placeholder="Select Account Group Options"
              options={accountTypes?.filter((type) => type.type === "LIVE")?.map((type) => ({
                value: type.title,
                label: type.title
              }))}
              value={selectBonus?.accountGroup}
              onChange={(e) => {
                let x = accountTypes?.filter((type)=> type.title === e);
                setAccountGroup(x[0]);
              }}
            />
            
            <AvFieldSelect
              name="bonusType"
              label="Bonus Type"
              placeholder="Select Bonus Type"
              options={BONUSTYPE.map((type) => ({
                value: type,
                label: type
              }))}
              value={selectBonus?.bonusType}
              onChange={(e) => {
                setBonusType(e);
              }}
            />
            
            {
              process !== "Lot" && (
                <div className="fs-3">
                  <AvRadioGroup 
                    inline 
                    name="isPercentage" 
                    value={selectBonus?.isPercentage ? "true" : "false"}
                    label={<span style={{ 
                      fontSize: "1rem",
                      fontWeight: "bold"
                    }}>Bonus Type</span>} 
                    validate={{
                      required: {
                        value: true,
                        errorMessage: "percentage is required"
                      }
                    }} 
                  >
                    <AvRadio label="Percentage" value="true" onClick={() => setBonusPercentage(true)}/>
                    <AvRadio label="Fixed Amount" value="false" onClick={() => setBonusPercentage(false)} />
                  </AvRadioGroup>
                </div>
              )
            }
            
            {bonusPercentage === false  && (
              <div className="mb-3 d-flex position-relative">
                <div className="position-relative w-100">
                  <AvField
                    name="amount"
                    label={t("Amount")}
                    placeholder={t("Enter Amount")}
                    value={selectBonus?.amount || ""}
                    type={process === "Welcome" ? "text" : "number"}
                    min={0}
                    max={process === "Deposit" ? 100 : 1000000000}
                    onKeyPress={(e) => {
                      if (!isNaN(e.key) && e.target.value.length > 0) {
                        return true;
                      }
                      if (!/[0-9]/.test(e.key)) {
                        e.preventDefault();
                      }
                    }}
                    validate={{
                      pattern: {
                        value: "^[0-9]+$",
                        errorMessage: "testing error message"
                      },
                    }}
                  />
                </div>
              </div>  
            )}
            
            {bonusPercentage && process !== "Lot" && (
              <>
                <div className="mb-3 d-flex position-relative">
                  <div className="position-relative w-100">
                    <AvField
                      name="percentage"
                      label={t("Percentage")}
                      placeholder={t("Enter Percentage")}
                      value={selectBonus?.percentage || ""}
                      type={"number"}
                      min={0}
                      max={900000000}
                      onKeyPress={(e) => {
                        if (!isNaN(e.key) && e.target.value.length > 0) {
                          return true;
                        }
                        if (!/[0-9]/.test(e.key)) {
                          e.preventDefault();
                        }
                      }}
                      validate={{
                        pattern: {
                          value: "^[0-9]+$",
                          // errorMessage: "max percentage is 100"
                        },
                      }}
                    />
                  </div>
                </div>  
                <div className="mb-3">
                  <AvField
                    name="maxAmount"
                    label={t("Max Amount")}
                    placeholder={t("Enter Max Amount")}
                    type="text"
                    value={selectBonus?.maxAmount || ""}
                    onKeyPress={(e) => {
                      if (!isNaN(e.key) && e.target.value.length > 0){
                        return true;
                      }
                      if (!/[0-9]/.test(e.key)) {
                        e.preventDefault();
                      }
                    }}
                    validate={{
                      pattern: {
                        value: "^[0-9]+$",
                        errorMessage: "testing error message"
                      },
                    }}
                  />
                </div>
              </>
            )}
       
            <div className="fs-3">
              <AvRadioGroup 
                inline 
                name="duration" 
                label={<span style={{ 
                  fontSize: "1rem",
                  fontWeight: "bold"
                }}>Duration</span>} 
                value={bonusDuration ? "false" : "true"}
                validate={{
                  required: {
                    value: true,
                    errorMessage: "duration is required"
                  }
                }} 
              >
                <AvRadio label="All Time" value="true" onClick={() => setBonusDuration(false)}/>
                <AvRadio label="Duration" value="false" onClick={() => setBonusDuration(true)} />
              </AvRadioGroup>
            </div>
            
            {bonusDuration && (
              <div>
                <AvField
                  name="dateFrom"
                  label={t("Date From")}
                  value={formatDateForInput(selectBonus?.dateFrom)}
                  type="date"
                  errorMessage={t("Select date From")}
                />
                <AvField
                  name="dateTo"
                  label={t("Date To")}
                  value={formatDateForInput(selectBonus?.dateTo)}
                  type="date"
                  errorMessage={t("Select date To")}
                />
              </div>
            )}
            {
              process === "Deposit" && (
                <AvField
                  name="bonusLimit"
                  label="Bonus Limit Per Account"
                  placeholder="Bonus Limit Per Account "
                  type="number"
                  value={selectBonus?.bonusLimit || ""}
                  min={1}
                />
              )
            }
            <AvField
              name="desc"
              label="Desc"
              placeholder="Desc "
              type="textarea"
              value={selectBonus?.desc || ""}
              validate={{
                required: {
                  value: true,
                  errorMessage: "Desc is required"
                }
              }}
            />
            
            <div className='text-center mt-3 p-2'>
              {
                updating
                  ? <Loader />
                  : <Button disabled={updating} type="submit" color="primary">
                    Edit
                  </Button>
              }
            </div>
          </AvForm>
        </ModalBody>
      </Modal>
    </>
  );
}

export default BonusEdit;